<div class="vy-flight-summary_wrapper align-center marginBottom-xl">
  <h1 class="headingXL text-left">
    {{'booking_details_component.flight_summary_header_component.title' | translate}}
    <span class="vy-flight-summary_record-locator">{{recordLocator}}</span>
    @if(channel === 'TTOO'){ -
    <span class="vy-flight-summary_channel">TTOO</span>
    } @if(channel === 'GDS'){ -
    <span class="vy-flight-summary_channel">GDS ({{gdsRecordLocator}})</span>
    }
  </h1>

  <span class="marginLeft-l marginRight-l headingXL">|</span>
  <vy-icon-text
    [type]="iconTextTypeEnum.BODY_L"
    [size]="iconTextSizeEnum.M"
    [label]="(paxAmount === 1 ? 'booking_details_component.flight_summary_header_component.pax_amount_singular' : 'booking_details_component.flight_summary_header_component.pax_amount_plural') | translate: {paxAmount: paxAmount}"
    [iconClass]="'ds-icon-user'"
    class="marginRight-s"
  ></vy-icon-text>
  <vy-badge
    [type]="badgeTypeEnum.NEGATIVE"
    [size]="badgeSizeEnum.S"
    [variant]="getStatusBadge()"
    badgeText="{{getStatusCopy() | translate}}"
  ></vy-badge>
</div>
